











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.ProductionSite.SetSensorStorageThresholdCommand')
    
    export class SetSensorStorageThresholdCommand {
        constructor( sensorId: number, storageThreshold: number ) {
            
                this.sensorId = sensorId;
            
                this.storageThreshold = storageThreshold;
            
        }

        
            public sensorId: number;
        
            public storageThreshold: number;
        
    }

    export interface ISetSensorStorageThresholdCommand {
        
            sensorId: number;
        
            storageThreshold: number;
        
    }

    export async function setSensorStorageThreshold( command: SetSensorStorageThresholdCommand ): Promise<CommandResult<void>>
    export async function setSensorStorageThreshold( { sensorId, storageThreshold }: ISetSensorStorageThresholdCommand ): Promise<CommandResult<void>>
    export async function setSensorStorageThreshold( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof SetSensorStorageThresholdCommand) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new SetSensorStorageThresholdCommand( model['sensorId'], model['storageThreshold'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace SetSensorStorageThresholdCommand.ExtraneousTypes {
        

        
    }

